/** A signature drawn on the pad arrives as a PNG data URL; the upload queue wants a file. */
export function dataUrlToBlob(dataUrl: string): Blob {
  const match = /^data:([^;,]+)(;base64)?,(.*)$/s.exec(dataUrl);
  if (!match) throw new Error('That is not a picture.');
  const [, type = 'image/png', base64, body = ''] = match;
  const text = base64 ? atob(body) : decodeURIComponent(body);
  const bytes = new Uint8Array(text.length);
  for (let i = 0; i < text.length; i += 1) bytes[i] = text.charCodeAt(i);
  return new Blob([bytes], { type });
}
